import React from 'react'

import { SvgIcon } from '@mui/material'

export default props => (
  <SvgIcon {...props}>
    <path d="M10.72 15.293c.434.58.651.869.917.972.234.091.492.091.726 0 .266-.103.483-.393.917-.972l2.8-3.733c.618-.824.927-1.236.92-1.58-.006-.3-.147-.582-.384-.767C16.345 9 15.83 9 14.8 9H9.2c-1.03 0-1.545 0-1.816.213-.237.185-.378.466-.384.766-.007.345.302.757.92 1.581l2.8 3.733z" />
  </SvgIcon>
)
